let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7XGvQ")).then(() => parcelRequire('82lFE'));